import { cx } from "emotion";
import PropTypes from "prop-types";
import React from "react";
import * as R from "ramda";
import { SearchReportsLabel, DateRange, RadioSet, Date } from "../../../";

const Search = (props) => {
  const dateProps = {
    handleRangePicked: props.handleDatePicked,
    dateFormat: props.dateFormat,
    showMonthYearPicker: props.showMonthYearPicker,
  };
  const childProps = {
    form: {
      onSubmit: props.onSubmit,
      "aria-label": "Report search form",
    },
    SearchReportsLabel: {
      title: props.isLoading ? "Loading Results..." : props.searchTitle,
      description: props.searchDescription,
      isLoading: props.isLoading,
    },
    dateRange: dateProps,
    singleDate: {
      ...dateProps,
      handleDatePick: props.handleDatePicked,
      selected: props.pickedDate,
    },
    submitButton: {
      disabled:
        props.isLoading ||
        (props.showDateSearch && !props.dateIsPicked) ||
        props.disabled,
      "aria-label": props.isLoading
        ? "Loading report data..."
        : "Run report with selected criteria",
      "aria-describedby": "submit-description",
    },
    radioSet: props.radioProps,
  };

  const radiosAvailable = R.not(
    R.isEmpty(R.path(["radioSet", "options"], childProps))
  );

  const getDateComponent = () => {
    const showRange = R.propOr(true, "range", props);
    if (showRange) return <DateRange {...childProps.dateRange} />;
    return <Date {...childProps.singleDate} />;
  };

  return (
    <form
      className={cx("users-report--search-content", props.className)}
      {...childProps.form}
      role="search"
      aria-describedby="search-description"
    >
      <div id="search-description" className="sr-only">
        Search form for generating reports. Select date range and grouping
        options, then run the report.
      </div>

      <SearchReportsLabel {...childProps.SearchReportsLabel} />

      {props.showDateSearch && (
        <div
          className="users-report--search-date"
          role="group"
          aria-label="Date range selection"
        >
          {getDateComponent()}
        </div>
      )}

      {radiosAvailable && (
        <div
          className="users-report__radio-set"
          role="group"
          aria-label="Report grouping options"
        >
          <RadioSet {...childProps.radioSet} />
        </div>
      )}

      <button
        className="users-report--search-btn"
        {...childProps.submitButton}
        type="submit"
      >
        {props.buttonText ? props.buttonText : "Run Report"}
      </button>
      {props.error && (
        <div
          role="alert"
          aria-live="assertive"
          className="error-message"
          aria-label="Error loading order"
        >
          <span className="error-icon" aria-hidden="true">
            ⚠️
          </span>
          {props.error}
        </div>
      )}
      <div id="submit-description" className="sr-only">
        Generates the report based on selected date range and grouping options
      </div>
    </form>
  );
};

Search.propTypes = {
  searchTitle: PropTypes.string,
  searchDescription: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  handleDatePicked: PropTypes.func.isRequired,
  dateIsPicked: PropTypes.bool,
  isLoading: PropTypes.bool,
  showMonthYearPicker: PropTypes.bool,
  dateFormat: PropTypes.string,
  radioProps: PropTypes.shape({
    options: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  }),
};

Search.defaultProps = {
  dateIsPicked: false,
  isLoading: false,
  showDateSearch: true,
  showMonthYearPicker: false,
  dateFormat: "yyyy-MM-dd",
  handleDatePicked: () => {},
};

export default Search;
